import { orchestrator } from 'satcheljs';
import {
    onCharmChanged,
    updateCharm,
    updateCharmSelection,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(onCharmChanged, actionMessage => {
    updateCharm(actionMessage.iconId);
    updateCharmSelection(actionMessage.iconId > 0);
});
